"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseDirectivesModule = /** @class */ (function () {
    function FuseDirectivesModule() {
    }
    return FuseDirectivesModule;
}());
exports.FuseDirectivesModule = FuseDirectivesModule;
